(function() {
  if (window.ProductSampleModalNewInitialized) return;
  window.ProductSampleModalNewInitialized = true;

  let lastLoadedProductId = null;

  function initModal() {
    const modals = document.querySelectorAll('#product-sample-modal-new');
    if (!modals || modals.length === 0) return;

    // Deduplicate in case multiple sections rendered the modal snippet
    let modal = modals[0];
    if (modals.length > 1) {
      for (let i = 0; i < modals.length; i++) {
        const form = modals[i].querySelector('#product-sample-form-new');
        if (form && (form.dataset.mainProductImage || form.dataset.mainProductId)) {
          modal = modals[i];
          break;
        }
      }
      for (let i = 0; i < modals.length; i++) {
        if (modals[i] !== modal) {
          modals[i].remove();
        }
      }
    }

    let lastTrigger = null;
    const sampleForm = modal.querySelector('#product-sample-form-new') || document.getElementById('product-sample-form-new');
    const sampleWallpaperType = modal.querySelector('#sample-wallpaper-type-new') || document.getElementById('sample-wallpaper-type-new');

    if (sampleForm && sampleForm.dataset.mainProductId) {
      lastLoadedProductId = String(sampleForm.dataset.mainProductId);
    }

    // Ensure all swatches have the active wallpaper design image displayed immediately upon initialization
    const initialImg = (sampleForm && sampleForm.dataset.mainProductImage) ||
      modal.querySelector('.sample-modal-new__image')?.currentSrc ||
      modal.querySelector('.sample-modal-new__image')?.src || '';
    const initialTitle = (sampleForm && sampleForm.dataset.mainProductTitle) || '';
    if (initialImg && initialImg.indexOf('no-image') === -1) {
      updateSwatchDesignImages(initialImg, initialTitle);
    }

    function resetFormState() {
      if (!sampleForm) return;

      sampleForm.querySelectorAll('.sample-material-radio-new').forEach(function(radio) {
        radio.checked = false;
      });

      if (sampleWallpaperType) {
        sampleWallpaperType.value = '';
      }

      const submitButton = sampleForm.querySelector('.sample-form-new__submit');
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.classList.remove('is-loading');
      }

      updateSummary();
    }

    function closeModal() {
      if (modal.open) {
        modal.close();
      }
      modal.classList.remove('is-active');
      document.querySelectorAll('[aria-controls="product-sample-modal-new"]').forEach(btn => btn.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('overflow-hidden');

      if (sampleForm) {
        const submitButton = sampleForm.querySelector('.sample-form-new__submit');
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove('is-loading');
        }
      }

      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(lastTrigger);
      } else if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus();
      }
    }

    function updateSwatchDesignImages(imageUrl, designTitle) {
      const swatchDesignImgs = modal.querySelectorAll('.sample-option-new__design');
      if (!swatchDesignImgs || swatchDesignImgs.length === 0) return;
      const altText = designTitle ? 'Sample with design: ' + designTitle : 'Sample with design';
      swatchDesignImgs.forEach(function(swatchImg) {
        if (imageUrl) {
          swatchImg.removeAttribute('srcset');
          swatchImg.removeAttribute('sizes');
          swatchImg.src = imageUrl;
          swatchImg.alt = altText;
          swatchImg.style.display = '';
        } else {
          swatchImg.style.display = 'none';
        }
      });
      modal.querySelectorAll('.sample-option-new__image[data-cart-image-preview]').forEach(function(optImg) {
        if (imageUrl) {
          optImg.setAttribute('data-design-url', imageUrl);
          if (designTitle) {
            const variantTitle = optImg.closest('.sample-option-new')?.querySelector('.sample-option-new__title')?.textContent?.trim() || '';
            optImg.setAttribute('data-preview-title', (variantTitle ? variantTitle + ' - ' : '') + designTitle);
          }
        } else {
          optImg.removeAttribute('data-design-url');
        }
      });
    }

    function populateProductData(data) {
      if (!data) return;

      const imgEl = modal.querySelector('.sample-modal-new__image') || modal.querySelector('.sample-modal-new__media img');
      if (imgEl) {
        if (data.image) {
          // Remove responsive image attributes so modern browsers do not stick to srcset of previous product
          imgEl.removeAttribute('srcset');
          imgEl.removeAttribute('sizes');
          imgEl.src = data.image;
          imgEl.alt = (data.title ? data.title + ' - Sample' : 'Sample');
          imgEl.style.display = '';
        } else {
          imgEl.style.display = 'none';
        }
      }

      if (data.image) {
        updateSwatchDesignImages(data.image, data.title);
        const mediaEl = modal.querySelector('.sample-modal-new__media');
        if (mediaEl) {
          mediaEl.setAttribute('data-preview-url', data.image);
          mediaEl.setAttribute('data-preview-title', (data.title ? data.title + ' - A4 Sample' : 'A4 Sample'));
        }
      }

      const skuEl = modal.querySelector('.sample-modal-new__sku');
      if (skuEl) {
        if (data.sku) {
          skuEl.textContent = data.sku;
          skuEl.style.display = '';
        } else {
          skuEl.style.display = 'none';
        }
      }

      if (sampleForm) {
        if (!sampleForm.dataset.originalProductImage && data.image) {
          sampleForm.dataset.originalProductImage = data.image;
        }
        sampleForm.dataset.mainProductTitle = data.title || '';
        sampleForm.dataset.mainProductHandle = data.handle || '';
        sampleForm.dataset.mainProductImage = data.image || '';
        sampleForm.dataset.mainProductId = data.id || '';
        sampleForm.dataset.mainProductSku = data.sku || '';
        sampleForm.dataset.mainProductUrl = data.url || (data.handle ? `/products/${data.handle}` : '');
      }
    }

    function isCustomPhotoTarget(data) {
      if (data && (data.handle === 'custom-photo' || String(data.id) === '10023246037303')) {
        return true;
      }
      if (sampleForm && (sampleForm.dataset.mainProductHandle === 'custom-photo' || String(sampleForm.dataset.mainProductId) === '10023246037303')) {
        return true;
      }
      if (window.location.pathname.indexOf('/products/custom-photo') !== -1 || document.querySelector('[data-wm-drag-drop]')) {
        return true;
      }
      return false;
    }

    async function getCustomPhotoFile() {
      if (window.currentCustomPhotoFile instanceof File || window.currentCustomPhotoFile instanceof Blob) {
        return window.currentCustomPhotoFile;
      }
      const fileInput = document.querySelector('input[type="file"]#file-upload');
      if (fileInput && fileInput.files && fileInput.files[0]) {
        return fileInput.files[0];
      }
      if (window.currentCustomPhotoUrl) {
        try {
          const res = await fetch(window.currentCustomPhotoUrl);
          const blob = await res.blob();
          return new File([blob], 'custom-photo.jpg', { type: blob.type || 'image/jpeg' });
        } catch (e) {
          console.warn('Error fetching currentCustomPhotoUrl:', e);
        }
      }
      const lsData = localStorage.getItem('wm_custom_photo_data');
      if (lsData) {
        try {
          const res = await fetch(lsData);
          const blob = await res.blob();
          const name = localStorage.getItem('wm_custom_photo_name') || 'custom-photo.jpg';
          const type = localStorage.getItem('wm_custom_photo_type') || 'image/jpeg';
          return new File([blob], name, { type });
        } catch (e) {
          console.warn('Error fetching localStorage photo data:', e);
        }
      }
      return null;
    }

    function generateA4CenterCropBlob(imageSrc) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () {
          try {
            const w = img.naturalWidth || img.width;
            const h = img.naturalHeight || img.height;
            const targetRatio = 297 / 210; // DIN A4 landscape = ~1.4142857
            const srcRatio = w / h;

            let cropW, cropH, cropX, cropY;
            if (srcRatio > targetRatio) {
              // Image is wider than A4 landscape: full height, crop horizontal sides
              cropH = h;
              cropW = Math.round(h * targetRatio);
              cropX = Math.round((w - cropW) / 2);
              cropY = 0;
            } else {
              // Image is taller or narrower than A4 landscape: full width, crop vertical edges
              cropW = w;
              cropH = Math.round(w / targetRatio);
              cropX = 0;
              cropY = Math.round((h - cropH) / 2);
            }

            const maxTargetWidth = 2400;
            const renderW = Math.min(cropW, maxTargetWidth);
            const renderH = Math.round(renderW / targetRatio);

            const canvas = document.createElement('canvas');
            canvas.width = renderW;
            canvas.height = renderH;
            const ctx = canvas.getContext('2d');
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';

            ctx.drawImage(img, cropX, cropY, cropW, cropH, 0, 0, renderW, renderH);

            canvas.toBlob(function (blob) {
              if (blob) {
                resolve(blob);
              } else {
                reject(new Error('Canvas toBlob failed'));
              }
            }, 'image/jpeg', 0.90);
          } catch (err) {
            reject(err);
          }
        };
        img.onerror = function (err) {
          reject(new Error('Failed to load image for A4 crop'));
        };
        img.src = imageSrc;
      });
    }

    function openModal(productData) {
      lastTrigger = document.activeElement;

      const isCustomPhoto = isCustomPhotoTarget(productData);
      if (isCustomPhoto) {
        const onPdp = !!document.querySelector('[data-wm-drag-drop]');
        if (onPdp) {
          const hasPhoto = typeof window.hasCustomPhoto === 'function' ? window.hasCustomPhoto() : !!window.hasUploadedCustomPhoto;
          if (!hasPhoto) {
            if (typeof window.focusCustomPhotoUpload === 'function') window.focusCustomPhotoUpload();
            if (typeof window.triggerCustomPhotoWarning === 'function') window.triggerCustomPhotoWarning();
            return;
          }
        } else {
          window.location.href = '/products/custom-photo?intent=sample#drop-area';
          return;
        }
      }

      if (productData) {
        // If opening for a different product, reset selections so user starts fresh
        if (productData.id && lastLoadedProductId && String(productData.id) !== String(lastLoadedProductId)) {
          resetFormState();
        }
        if (productData.id) {
          lastLoadedProductId = String(productData.id);
        }
        populateProductData(productData);
      } else {
        // When opening without explicit productData (e.g. from PDP button), ensure active design image is updated on swatches
        const activeImg = (sampleForm && sampleForm.dataset.mainProductImage) ||
          modal.querySelector('.sample-modal-new__image')?.currentSrc ||
          modal.querySelector('.sample-modal-new__image')?.src || '';
        const activeTitle = (sampleForm && sampleForm.dataset.mainProductTitle) || '';
        if (activeImg && activeImg.indexOf('no-image') === -1) {
          updateSwatchDesignImages(activeImg, activeTitle);
        }
      }

      if (isCustomPhoto && window.currentCustomPhotoUrl) {
        const imgEl = modal.querySelector('.sample-modal-new__image') || modal.querySelector('.sample-modal-new__media img');
        if (imgEl) {
          imgEl.removeAttribute('srcset');
          imgEl.removeAttribute('sizes');
          imgEl.src = window.currentCustomPhotoUrl;
          imgEl.style.display = '';
        }
        if (sampleForm) {
          sampleForm.dataset.mainProductImage = window.currentCustomPhotoUrl;
        }
        updateSwatchDesignImages(window.currentCustomPhotoUrl, 'Custom Photo');
      }

      if (!modal.open) {
        modal.showModal();
      }
      modal.classList.add('is-active');
      document.querySelectorAll('[aria-controls="product-sample-modal-new"]').forEach(btn => btn.setAttribute('aria-expanded', 'true'));
      document.body.classList.add('overflow-hidden');
      requestAnimationFrame(function() {
        const firstFocusable = modal.querySelector('.sample-material-radio-new, .sample-modal-new__close');
        if (typeof trapFocus === 'function') {
          trapFocus(modal, firstFocusable || modal);
        } else if (firstFocusable) {
          firstFocusable.focus();
        }
      });
    }

    // Expose global functions
    window.openSampleModal = openModal;
    window.closeSampleModal = closeModal;
    window.resetSampleForm = resetFormState;
    window.openSamplePopup = function(id, title, handle, image, sku, url) {
      openModal({ id: id, title: title, handle: handle, image: image, sku: sku, url: url || (handle ? `/products/${handle}` : '') });
    };

    // Summary calculation
    function updateSummary() {
      if (!sampleForm) return;

      const selectedVariants = Array.from(sampleForm.querySelectorAll('.sample-material-radio-new:checked'));
      const summary = sampleForm.querySelector('.sample-form-new__summary');
      const countEl = sampleForm.querySelector('.sample-form-new__summary-count');
      const listEl = sampleForm.querySelector('.sample-form-new__summary-list');
      const totalEl = sampleForm.querySelector('.sample-form-new__summary-total');
      const btnText = sampleForm.querySelector('.btn-text');
      
      if (selectedVariants.length === 0) {
        if (summary) summary.style.display = 'none';
        if (btnText) btnText.textContent = btnText.dataset.defaultText || 'Add selected samples to cart';
        const submitBtn = sampleForm.querySelector('.sample-form-new__submit');
        if (submitBtn) submitBtn.setAttribute('aria-label', (btnText && btnText.textContent) || 'Add selected samples to cart');
        return;
      }

      if (summary) summary.style.display = 'flex';
      if (countEl) countEl.textContent = selectedVariants.length;
      const labelEl = sampleForm.querySelector('.sample-form-new__summary-label');
      if (labelEl) {
        const oneText = sampleForm.dataset.labelMaterialOne || 'MATERIAL SELECTED';
        const otherText = sampleForm.dataset.labelMaterialOther || 'MATERIALS SELECTED';
        labelEl.textContent = selectedVariants.length === 1 ? oneText : otherText;
      }
      
      const titles = selectedVariants.map(v => v.dataset.title || '').filter(Boolean);
      if (listEl) listEl.textContent = titles.join(' + ');

      let totalCents = 0;
      selectedVariants.forEach(v => {
        const price = parseInt(v.dataset.price || '0', 10);
        totalCents += price;
      });
      
      const currencyCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      const locale = document.documentElement.lang || 'en-US';
      const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: totalCents % 100 === 0 ? 0 : 2
      });

      if (totalEl) {
        if (totalCents === 0) {
          totalEl.textContent = sampleForm.dataset.labelFree || 'Free';
        } else {
          totalEl.textContent = formatter.format(totalCents / 100);
        }
      }

      if (btnText) {
        const count = selectedVariants.length;
        const templateOne = sampleForm.dataset.btnAddSampleOne || btnText.dataset.defaultText || 'Add selected samples to cart';
        const templateOther = sampleForm.dataset.btnAddSampleOther || btnText.dataset.defaultText || 'Add selected samples to cart';
        const template = count === 1 ? templateOne : templateOther;
        btnText.textContent = template.replace('[count]', count).replace('{count}', count).replace('{{ count }}', count);
      }
      const submitBtn = sampleForm.querySelector('.sample-form-new__submit');
      if (submitBtn) {
        submitBtn.setAttribute('aria-label', (btnText && btnText.textContent) || 'Add selected samples to cart');
      }
    }

    // Attach modal-internal listeners only once
    if (modal.dataset.modalEventsAttached !== 'true') {
      modal.dataset.modalEventsAttached = 'true';

      modal.querySelectorAll('[data-sample-close]').forEach(function(el) {
        el.addEventListener('click', closeModal);
      });

      if (!('closedBy' in HTMLDialogElement.prototype)) {
        modal.addEventListener('click', function(event) {
          if (event.target !== modal) return;

          const rect = modal.getBoundingClientRect();
          const isDialogContent = (
            rect.top <= event.clientY &&
            event.clientY <= rect.top + rect.height &&
            rect.left <= event.clientX &&
            event.clientX <= rect.left + rect.width
          );

          if (isDialogContent) return;

          closeModal();
        });
      }

      modal.addEventListener('close', function() {
        closeModal();
      });

      // Browser back/forward navigation (bfcache) restore handlers
      window.addEventListener('pageshow', function (event) {
        closeModal();
        resetFormState();
      });

      window.addEventListener('pagehide', function () {
        closeModal();
        resetFormState();
      });

      // Dynamic custom photo update listeners
      document.addEventListener('custom-photo:uploaded', function (e) {
        const url = (e.detail && e.detail.url) || window.currentCustomPhotoUrl;
        if (!url) return;
        const imgEl = modal.querySelector('.sample-modal-new__image') || modal.querySelector('.sample-modal-new__media img');
        if (imgEl) {
          imgEl.removeAttribute('srcset');
          imgEl.removeAttribute('sizes');
          imgEl.src = url;
          imgEl.style.display = '';
        }
        const mediaEl = modal.querySelector('.sample-modal-new__media');
        if (mediaEl) {
          mediaEl.setAttribute('data-preview-url', url);
          mediaEl.setAttribute('data-preview-title', 'Custom Photo - A4 Sample');
        }
        if (sampleForm) {
          sampleForm.dataset.mainProductImage = url;
        }
        updateSwatchDesignImages(url, 'Custom Photo');
      });

      document.addEventListener('custom-photo:cleared', function () {
        if (sampleForm && sampleForm.dataset.originalProductImage) {
          const imgEl = modal.querySelector('.sample-modal-new__image') || modal.querySelector('.sample-modal-new__media img');
          if (imgEl) {
            imgEl.src = sampleForm.dataset.originalProductImage;
          }
          const mediaEl = modal.querySelector('.sample-modal-new__media');
          if (mediaEl) {
            mediaEl.setAttribute('data-preview-url', sampleForm.dataset.originalProductImage);
            mediaEl.setAttribute('data-preview-title', (sampleForm.dataset.mainProductTitle ? sampleForm.dataset.mainProductTitle + ' - A4 Sample' : 'A4 Sample'));
          }
          sampleForm.dataset.mainProductImage = sampleForm.dataset.originalProductImage;
          updateSwatchDesignImages(sampleForm.dataset.originalProductImage, sampleForm.dataset.mainProductTitle);
        }
      });

      // Zoom preview for material option texture thumbnails
      modal.querySelectorAll('.sample-option-new__image[data-cart-image-preview]').forEach(function (imgContainer) {
        function triggerSwatchZoom(e) {
          e.preventDefault();
          e.stopPropagation();

          const rawUrl = imgContainer.dataset.masterUrl || imgContainer.dataset.previewUrl || imgContainer.querySelector('.sample-option-new__texture')?.src || imgContainer.querySelector('img')?.src;
          if (!rawUrl) return;

          const title = imgContainer.dataset.previewTitle || 'Material Texture Sample';
          const filename = rawUrl.split('/').pop()?.split('?')[0] || '';

          if (window.CartImageModalController) {
            window.CartImageModalController.open(rawUrl, title, filename, imgContainer);
          } else if (typeof window.openCartImageModal === 'function') {
            window.openCartImageModal(rawUrl, title, filename, imgContainer);
          } else if (typeof window.loadCartModalAssets === 'function') {
            window.loadCartModalAssets(function () {
              if (window.CartImageModalController) {
                window.CartImageModalController.open(rawUrl, title, filename, imgContainer);
              }
            });
          }
        }

        imgContainer.addEventListener('click', triggerSwatchZoom);
        imgContainer.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            triggerSwatchZoom(e);
          }
        });
      });

      // Zoom preview for main A4 sample proof media
      const mainMedia = modal.querySelector('.sample-modal-new__media');
      if (mainMedia) {
        function triggerMainMediaZoom(e) {
          const activeImg = mainMedia.querySelector('.sample-modal-new__image') || mainMedia.querySelector('img');
          if (!activeImg || !activeImg.src || activeImg.style.display === 'none') return;

          e.preventDefault();
          e.stopPropagation();

          const title = mainMedia.getAttribute('data-preview-title') ||
            (sampleForm && sampleForm.dataset.mainProductTitle ? `${sampleForm.dataset.mainProductTitle} - A4 Sample` : 'A4 Sample');
          const rawUrl = mainMedia.getAttribute('data-preview-url') || activeImg.currentSrc || activeImg.src;
          const filename = rawUrl.split('/').pop()?.split('?')[0] || '';

          if (window.CartImageModalController) {
            window.CartImageModalController.open(rawUrl, title, filename, mainMedia);
          } else if (typeof window.openCartImageModal === 'function') {
            window.openCartImageModal(rawUrl, title, filename, mainMedia);
          } else if (typeof window.loadCartModalAssets === 'function') {
            window.loadCartModalAssets(function () {
              if (window.CartImageModalController) {
                window.CartImageModalController.open(rawUrl, title, filename, mainMedia);
              }
            });
          }
        }

        mainMedia.addEventListener('click', triggerMainMediaZoom);
        mainMedia.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            triggerMainMediaZoom(e);
          }
        });
      }

      if (sampleForm) {
        sampleForm.querySelectorAll('.sample-material-radio-new').forEach(function (radio) {
          radio.addEventListener('change', function () {
            if (sampleWallpaperType) {
              sampleWallpaperType.value = this.dataset.title || '';
            }
            updateSummary();
          });
        });

        sampleForm.addEventListener('submit', async function (event) {
          event.preventDefault();

          const selectedVariants = Array.from(sampleForm.querySelectorAll('.sample-material-radio-new:checked'));
          const submitButton = sampleForm.querySelector('.sample-form-new__submit');

          if (selectedVariants.length === 0) {
            alert('Please select at least one sample type.');
            return;
          }

          if (submitButton) {
            submitButton.disabled = true;
            submitButton.classList.add('is-loading');
          }

          const ds = sampleForm.dataset;
          const isCustomPhoto = isCustomPhotoTarget();

          if (isCustomPhoto) {
            const hasPhoto = typeof window.hasCustomPhoto === 'function' ? window.hasCustomPhoto() : !!window.hasUploadedCustomPhoto;
            if (!hasPhoto) {
              closeModal();
              if (submitButton) {
                submitButton.disabled = false;
                submitButton.classList.remove('is-loading');
              }
              if (typeof window.triggerCustomPhotoWarning === 'function') window.triggerCustomPhotoWarning();
              if (typeof window.focusCustomPhotoUpload === 'function') window.focusCustomPhotoUpload();
              return;
            }

            try {
              const rawFile = await getCustomPhotoFile();
              if (!rawFile) {
                throw new Error('Please upload an image before ordering a sample.');
              }

              const photoUrl = window.currentCustomPhotoUrl || (rawFile ? URL.createObjectURL(rawFile) : '');
              const croppedBlob = await generateA4CenterCropBlob(photoUrl);
              const croppedFile = new File([croppedBlob], `sample-a4-proof-${Date.now()}.jpg`, { type: 'image/jpeg' });

              const mainTitle = ds.mainProductTitle || 'Custom Photo Wallpaper';
              const mainSku = ds.mainProductSku || '';
              const wallpaperDesign = mainSku ? `${mainTitle}; ${mainSku}` : mainTitle;
              const originalUrl = ds.mainProductUrl || '/products/custom-photo';

              for (const variant of selectedVariants) {
                const formData = new FormData();
                formData.append('id', variant.value);
                formData.append('quantity', 1);

                // Cropped horizontal DIN A4 sample proof for customer, cart & checkout - appended FIRST directly under title
                formData.append('properties[Your design]', croppedFile, `sample-a4-${variant.dataset.title ? variant.dataset.title.toLowerCase().replace(/[^a-z0-9]/g, '-') : 'proof'}.jpg`);
                // Internal/admin compatibility
                formData.append('properties[_Custom Image]', croppedFile, `sample-a4-${variant.dataset.title ? variant.dataset.title.toLowerCase().replace(/[^a-z0-9]/g, '-') : 'proof'}.jpg`);
                // Raw master uncompressed upload for staff in Shopify Admin
                formData.append('properties[_Original Upload]', rawFile, rawFile.name || 'original-upload.jpg');

                formData.append('properties[_Sample Material]', variant.dataset.title || '');
                formData.append('properties[Wallpaper Design]', wallpaperDesign);
                formData.append('properties[_Sample Product]', ds.sampleProductTitle || '');
                formData.append('properties[_Sample Product Handle]', ds.sampleProductHandle || '');
                formData.append('properties[_Main Product]', ds.mainProductTitle || '');
                formData.append('properties[_Main Product Handle]', ds.mainProductHandle || '');
                formData.append('properties[_Main Product Id]', ds.mainProductId || '');
                formData.append('properties[_Wallpaper Type]', variant.dataset.title || '');
                formData.append('properties[_original_url]', originalUrl);

                const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Accept': 'application/json'
                  },
                  body: formData
                });

                if (!response.ok) {
                  const errorPayload = await response.json().catch(() => ({}));
                  throw new Error(errorPayload.description || errorPayload.message || 'Could not add sample to cart.');
                }
              }

              closeModal();
              resetFormState();
              window.location.href = window.routes?.cart_url || '/cart';
              return;
            } catch (error) {
              console.error('Custom photo sample submission error:', error);
              alert(error.message || 'Could not add sample to cart.');
              if (submitButton) {
                submitButton.disabled = false;
                submitButton.classList.remove('is-loading');
              }
              return;
            }
          }

          // Default submission path for regular catalog wallpaper samples
          const mainTitle = ds.mainProductTitle || '';
          const mainSku = ds.mainProductSku || '';
          const wallpaperDesign = mainSku ? `${mainTitle}; ${mainSku}` : mainTitle;
          const originalImage = ds.mainProductImage || '';
          const originalUrl = ds.mainProductUrl || (ds.mainProductHandle ? `/products/${ds.mainProductHandle}` : '');

          const items = selectedVariants.map(variant => {
            return {
              id: Number(variant.value),
              quantity: 1,
              properties: {
                'Wallpaper Design': wallpaperDesign,
                '_Sample Product': ds.sampleProductTitle || '',
                '_Sample Product Handle': ds.sampleProductHandle || '',
                '_Main Product': ds.mainProductTitle || '',
                '_Main Product Handle': ds.mainProductHandle || '',
                '_Main Product Id': ds.mainProductId || '',
                '_Wallpaper Type': variant.dataset.title || '',
                '_Main Product Image': ds.mainProductImage || '',
                '_original_image': originalImage,
                '_original_url': originalUrl
              }
            };
          });

          try {
            const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ items: items })
            });

            if (!response.ok) {
              const errorPayload = await response.json().catch(function () {
                return {};
              });
              throw new Error(errorPayload.description || errorPayload.message || 'Could not add sample to cart.');
            }

            // Clean up modal state and reset form before navigating to /cart so any bfcache snapshot is clean
            closeModal();
            resetFormState();

            window.location.href = window.routes?.cart_url || '/cart';
          } catch (error) {
            alert(error.message || 'Could not add sample to cart.');
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.classList.remove('is-loading');
            }
          }
        });
      }
    }

    updateSummary();

    // Shopify Customizer support
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function() {
        initModal();
      });
      document.addEventListener('shopify:block:select', function(event) {
        if (modal.contains(event.target) || modal.getAttribute('data-shopify-editor-block') === `{"id":"${event.detail.blockId}"}`) {
          openModal();
        }
      });
      document.addEventListener('shopify:block:deselect', function(event) {
        if (modal.contains(event.target) || modal.getAttribute('data-shopify-editor-block') === `{"id":"${event.detail.blockId}"}`) {
          closeModal();
        }
      });
    }
  }

  // Global click listener for cards or other sample modal triggers (delegated on document)
  document.addEventListener('click', function (event) {
    const btn = event.target.closest(
      '.js-open-sample-popup, [data-open-sample-modal], .order-sample_btn, [aria-controls="product-sample-modal-new"]'
    );
    if (!btn) return;
    if (btn.hasAttribute('data-sample-close') || btn.closest('.sample-modal-new')) return;

    const productData = {
      id: btn.dataset.productId || '',
      title: btn.dataset.productTitle || '',
      handle: btn.dataset.productHandle || '',
      image: btn.dataset.productImage || '',
      sku: btn.dataset.productSku || '',
      url: btn.dataset.productUrl || (btn.dataset.productHandle ? `/products/${btn.dataset.productHandle}` : '')
    };

    const isCustomPhoto = (
      productData.handle === 'custom-photo' ||
      String(productData.id) === '10023246037303' ||
      window.location.pathname.indexOf('/products/custom-photo') !== -1 ||
      !!document.querySelector('[data-wm-drag-drop]')
    );

    if (isCustomPhoto) {
      const onPdp = !!document.querySelector('[data-wm-drag-drop]');
      if (onPdp) {
        const hasPhoto = typeof window.hasCustomPhoto === 'function' ? window.hasCustomPhoto() : !!window.hasUploadedCustomPhoto;
        if (!hasPhoto) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof window.focusCustomPhotoUpload === 'function') window.focusCustomPhotoUpload();
          if (typeof window.triggerCustomPhotoWarning === 'function') window.triggerCustomPhotoWarning();
          return;
        }
      } else {
        event.preventDefault();
        event.stopPropagation();
        window.location.href = '/products/custom-photo?intent=sample#drop-area';
        return;
      }
    }

    event.preventDefault();

    if (window.openSampleModal) {
      window.openSampleModal((productData.title || productData.handle || productData.id) ? productData : null);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModal);
  } else {
    initModal();
  }
})();
